export const REQUEST_CUSTOM_EVENTS = {
    OPEN_ASSIGN_EXEC_DIALOG: 'OPEN_ASSIGN_EXEC_DIALOG',
    CLOSE_ASSIGN_EXEC_DIALOG: 'CLOSE_ASSIGN_EXEC_DIALOG',
    UPDATE_REQ_DETAILS: 'UPDATE_REQ_DETAILS',
    REFETCH_REQ_DETAILS: 'REFETCH_REQ_DETAILS',
    OPEN_EXEC_OTP: 'OPEN_EXEC_OTP',
    CLOSE_EXEC_OTP: 'CLOSE_EXEC_OTP',
};

export const OTP_OPTIONS = {
    EMPTY: '',
    SAMPLE_COLLECTION: 'SAMPLE_COLLECTION',
    SAMPLE_SUBMISSION: 'SAMPLE_SUBMISSION',
};